module.exports = __webpack_public_path__ + "img/Chat Icon (Not active).5f227087.svg";